module.exports = __webpack_public_path__ + "static/img/Spinda.5bc8798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Spinda.png
// module id = eoa+
// module chunks = 1